import { useState } from "react";
import api from "../../../services/api";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import DnaLoader from "../../loader/DnaLoader";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = value;

    switch (name) {
      case "name":
      case "subject":
        newValue = value.replace(/[^A-Za-z\s\-_,()]/g, "").slice(0, 50);
        break;

      case "phone":
        newValue = value.replace(/[^0-9]/g, "").slice(0, 10);
        break;

      case "email":
        newValue = value.replace(/\s/g, "").slice(0, 75);
        break;

      case "message":
        newValue = value.slice(0, 250);
        break;

      default:
        break;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const emailRegex =
      /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(formData.email)) {
      setLoading(false);
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      await api.post(`/api/send-contact`, formData);
      setLoading(false);
      
      await Swal.fire({
        title: "Success!",
        text: "Appointment sent successfully!",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
        width: 450, 
      });

      setFormData({
        name: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
        consent: false,
      });
    } catch (err) {
      toast.error("Something went wrong. Try again!");
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <>
      {loading && <DnaLoader />}

      <div className="appointment-box">
        <div className="p-4">
          <form onSubmit={handleSubmit}>

            <input
              name="name"
              type="text"
              className="form-control mb-2"
              placeholder="Name:"
              title="Enter your name"
              value={formData.name}
              onChange={handleChange}
              maxLength={50}
              required
            />

            <input
              name="phone"
              type="text"
              className="form-control mb-2"
              placeholder="Phone No:"
              value={formData.phone}
              onChange={handleChange}
              maxLength={10}
              minLength={10}
              pattern="[0-9]{10}"
              title="Enter your mobile number"
              required
            />

            <input
              name="email"
              type="text"
              className="form-control mb-2"
              placeholder="Email:"
              title="Enter your email"
              value={formData.email}
              onChange={handleChange}
              maxLength={75}
            />

            <input
              name="subject"
              type="text"
              className="form-control mb-2"
              placeholder="Subject:"
              title="Enter subject"
              value={formData.subject}
              onChange={handleChange}
              maxLength={50}
              required
            />

            <textarea
              name="message"
              className="form-control mb-3"
              placeholder="Message:"
              rows="3"
              title="Enter your message"
              value={formData.message}
              onChange={handleChange}
              maxLength={250}
              required
            />

            <div className="form-check mb-3">
              <input
                name="consent"
                className="form-check-input"
                type="checkbox"
                id="consentCheck"
                checked={formData.consent}
                onChange={handleChange}
                required
              />
              <label className="form-check-label cursor-pointer" htmlFor="consentCheck">
                I consent to get contacted from Lifeline Tulasi Hospital.
              </label>
            </div>

            <div className="text-center">
              <button type="submit" className="about-btn">
                Submit
              </button>
            </div>

          </form>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
